import { render, staticRenderFns } from "./ExternalOrderDialog.vue?vue&type=template&id=397f06c4"
import script from "./ExternalOrderDialog.vue?vue&type=script&lang=js"
export * from "./ExternalOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports